
export const tutorials = {
  'backoffice.sidebarUser.sections.tutorials.items.theClubRegistration': 'The Club Registration',

  // Tutorials Index Page
  'tutorials.index.title': 'Learning Center',
  'tutorials.index.subtitle': 'Step-by-step guides to help you get started',

  // Common
  'tutorials.common.downloadPdf': 'Download PDF Guide',
  'tutorials.common.pdfAlternative': 'Download our comprehensive PDF guide',
  'tutorials.common.watchVideo': 'Watch Tutorial Video',
  'tutorials.common.pdfName': 'TheClub_Registration_Guide_EN.pdf',

  // Tutorial: Radex Markets Registration
  'tutorials.radexRegistration.title': 'Registration in Radex Markets Broker',
  'tutorials.radexRegistration.description': 'Learn how to open and set up your account on Radex Markets, the regulated broker partner of TheClub. This guide covers account creation, document submission, and identity verification.',
  'tutorials.radexRegistration.links.registration': 'Radex Markets Registration',

  // Tutorial: Wire Transfer
  'tutorials.wireTransfer.title': 'Funding Account via Wire Transfer',
  'tutorials.wireTransfer.description': 'A complete walkthrough on how to fund your Radex Markets account using a bank wire transfer. Covers bank details, processing times, and confirmation steps.',
  'tutorials.wireTransfer.links.login': 'Radex Markets Login',

  // Tutorial: Card Funding
  'tutorials.cardFunding.title': 'Funding Account via Credit/Debit Card',
  'tutorials.cardFunding.description': 'A complete walkthrough on how to fund your Radex Markets account using a Visa or Mastercard credit or debit card. Fast, secure, and ready in minutes.',
  'tutorials.cardFunding.links.login': 'Radex Markets Login',

  // Tutorial: PAMM Registration
  'tutorials.pammRegistration.title': 'Registration in TheClub PAMM Account',
  'tutorials.pammRegistration.description': 'Learn how to link your Radex Markets account to TheClub\'s PAMM system so your funds are managed by our professional traders.',
  'tutorials.pammRegistration.links.institutional': 'Institutional Trading PAMM Account',
  'tutorials.pammRegistration.links.spartan': 'Spartan AI Trading PAMM Account',
  'tutorials.pammRegistration.links.login': 'PAMM Account Login',

  // Tutorial: TheClub Account Creation
  'tutorials.theclubAccount.title': 'Creating the TheClub Account',
  'tutorials.theclubAccount.description': 'Step-by-step instructions to create your TheClub membership account — from signing up on the platform to completing your PAMM account association.',
  'tutorials.theclubAccount.links.registration': 'TheClub Registration Page',
  'tutorials.theclubAccount.links.registrationNote': 'Use the link provided by your Sponsor',
  'tutorials.theclubAccount.links.website': 'TheClub Website',
};
